"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Title_1 = __importDefault(require("../Title"));
var DealerInfo_1 = __importDefault(require("../DealerInfo"));
var CarTitle = function (props) {
    var title = props.title, dealerInfo = props.dealerInfo;
    return (react_1.default.createElement("div", { className: "aui-CarTitle" },
        react_1.default.createElement("div", { className: "container aui-CarTitle-container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: dealerInfo ? 'col-lg-7' : 'col-auto' },
                    react_1.default.createElement(Title_1.default, { level: "h1" }, title)),
                dealerInfo && (react_1.default.createElement("div", { className: "col-lg-5 aui-CarTitle-dealer-info" },
                    react_1.default.createElement(DealerInfo_1.default, null, dealerInfo)))))));
};
CarTitle.displayName = 'CarTitle';
exports.default = CarTitle;
